import PropTypes from 'prop-types';
import React, { ReactNode } from 'react';

interface ErrorBoundaryState {
  error?: Error;
}

export interface ErrorBoundaryProps {
  children: ReactNode;
  errorMessage?: string;
}

/*
  Provides a React ErrorBoundary wrapper for components, content within a component, or layouts.
 */
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static propTypes = {
    errorMessage: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  };

  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }

  componentDidCatch(error: Error) {
    // You can also log the error to an error reporting service
    this.setState({
      error: error,
    });
  }

  render() {
    const { errorMessage } = this.props;

    if (this.state.error) {
      if (errorMessage) {
        return <div>Error: {errorMessage}</div>;
      }

      return <div>Error</div>;
    }

    return this.props.children;
  }
}
